import React, { useEffect, useRef } from 'react';
import Typed from 'typed.js';

const TypedText = ({ typedTextStrings }) => {
  const typedElement = useRef(null);

  useEffect(() => {
    const options = {
      strings: typedTextStrings,
      typeSpeed: 90,
      backSpeed: 70,
      loop: true,
    };

    const typed = new Typed(typedElement.current, options);

    return () => {
      typed.destroy();
    };
  }, [typedTextStrings]); 

  return <span className="input" ref={typedElement} />;
}

export default TypedText;
